import React from "react";
import { FacebookShareButton, WhatsappShareButton, TwitterShareButton, LinkedinShareButton } from "react-share";
import CustomImage from "./CustomImage";
import InstagramShareButton from "./InstagramShareButton";
import styles from "../styles/newspressdetails.module.scss";

interface SocialShareButtonsProps {
  currentUrl: string;
}

const SocialShareButtons: React.FC<SocialShareButtonsProps> = ({ currentUrl }) => {
  return (
    <>
      <div>
        <WhatsappShareButton url={currentUrl}>
          <div className={styles.centerIcon}>
            <CustomImage src="/new-images/whats-app.svg" width={36} height={36} alt="WhatsApp" />
          </div>
        </WhatsappShareButton>
      </div>
      <div>
        <FacebookShareButton url={currentUrl}>
          <div className={styles.centerIcon}>
            <CustomImage src="/new-images/face-book.svg" width={36} height={36} alt="Facebook" />
          </div>
        </FacebookShareButton>
      </div>
      <div>
        <InstagramShareButton url={currentUrl}>
          <div className={styles.centerIcon}>
            <CustomImage src="/new-images/insta.svg" width={36} height={36} alt="Instagram" />
          </div>
        </InstagramShareButton>
      </div>
      <div>
        <LinkedinShareButton url={currentUrl}>
          <div className={styles.centerIcon}>
            <CustomImage src="/new-images/linkedin-icon-a.svg" width={36} height={36} alt="LinkedIN" />
          </div>
        </LinkedinShareButton>
      </div>
      <div>
        <TwitterShareButton url={currentUrl}>
          <div className={styles.centerIcon}>
            <CustomImage src="/new-images/twitter.svg" width={36} height={36} alt="Twitter" />
          </div>
        </TwitterShareButton>
      </div>
    </>
  );
};

export default SocialShareButtons;
